export const store = {
  // colors
  expBackgroundColor: "#000000",
  cardColor: "#D9D9D9",

  // projects
  aboutMe: {
    title: "About Me",
    content: (
      <>
        <article>
          <p>
            With over 5 years of professional experience, I specialize in
            front&#8209;end development, crafting dynamic and visually engaging
            digital experiences. As an Interactive Developer at AbelsonTaylor, I
            contributed to impactful web projects, leveraging NodeJS, React, and
            Greensock to deliver high&#8209;quality solutions. I am passionate about
            creating user-centered designs and innovative interactive content
            that aligns with organizational goals and fosters collaboration.
          </p>
          <p>
            At AbelsonTaylor, I built responsive websites, interactive quizzes,
            and animated campaigns using JavaScript, Sass, and HTML templates.
            By integrating tools like Three.js, I enabled immersive user
            experiences and consistently met tight deadlines. My ability to
            adapt to evolving technologies and collaborate with teams ensured
            the delivery of high-impact solutions for diverse digital
            initiatives.
          </p>
        </article>
        <article className="contact">
          <h1>
            Contact
          </h1>
        </article>
        <article>
          <a href="https://www.linkedin.com/in/thomas-ignarri-07ba8680/" target="_blank">LinkedIn</a>
          <a href="mailto:tom.ignarri@gmail.com">Email</a>
          <a href="https://github.com/tomignarri" target="_blank">GitHub</a>
          <a href="https://bitbucket.org/tomignarri/" target="_blank">Bitbucket</a>
        </article>
      </>
    ),
  },
  iperbot: {
    title: "IPERBOT",
    techUsed: "Unity, C#",
    links: (
      <>
        <a href="https://iperdesign.com/iperbot-game/" target="_blank">
          Play the game
        </a>
        <a
          href="https://bitbucket.org/tomignarri/iperbot/src/master/"
          target="_blank"
        >
          Bitbucket
        </a>
      </>
    ),
    content: (
      <>
        <article>
          <p>
            IperBot is an internal project developed by several interns and
            designers at Iperdesign. This was my first project in Unity. It was
            a deep dive into a very unfamiliar API which made for a challenging
            experience.
          </p>
          <p>
            Testing the game with users was a major part of this project as
            well. It was important that the difficulty was appropriate in such a
            way that experienced gamers could have fun and less experienced
            gamers would not be overwhelmed.
          </p>
        </article>
        <article>
          <img alt="iperbot-img-2" draggable="false" src="gifs/iperbot_2.gif" />
          <img alt="iperbot-img-1" draggable="false" src="gifs/iperbot_1.gif" />
        </article>
      </>
    ),
  },

  csl: {
    title: "CSL BEHRING",
    techUsed: "Javascript, HTML, SCSS, ASP.NET, C#, Greensock",
    links: (
      <>
        <a
          href="https://pharmawards.com/2023-w3-hemevolution-mkt-integrated-campaign/"
          target="_blank"
        >
          View campaign
        </a>
      </>
    ),
    content: (
      <>
        <article>
          <p>
            This campaign was one to which I contributed during my time at
            AbelsonTaylor. Working closely with my colleagues, we played a key
            role in the digital execution of an educational initiative
            showcasing advances in gene therapy for
            Hemophilia&nbsp;B&nbsp;treatment.
          </p>
          <p>
            My role was to spearhead the development of a website for patients.
            Our designers created a variety of interactive elements and
            animations, which I implemented using the Greensock library.
            Pictured on the right is a form that communicated with an api built
            in ASP.NET.
          </p>
        </article>
        <article>
          <video 
            preload="auto" 
            autoPlay 
            loop 
            muted={true}
            playsInline 
            disablePictureInPicture
            poster="images/hemevolution-poster-1.jpg"
          >
            <source src="videos/hemevolution-video-1.mp4" type="video/mp4" />
          </video>
          <video 
            preload="auto" 
            autoPlay 
            loop 
            muted={true}
            playsInline 
            disablePictureInPicture
            poster="images/hemevolution-poster-2.jpg"
          >
            <source src="videos/hemevolution-video-2.mp4" type="video/mp4" />
          </video>
        </article>
      </>
    ),
  },

  arcutis: {
    title: "ARCUTIS",
    techUsed: "Javascript, HTML, SCSS, Drupal, React, PHP",
    links: (
      <>
        <a
          href="https://pharmawards.com/2024-arcutis-dtp-cream-that-can/#website"
          target="_blank"
        >
          View campaign
        </a>
        <a
          href="https://www.zoryve.com/save-with-zoryve-direct"
          target="_blank"
        >
          View the website
        </a>
      </>
    ),
    content: (
      <>
        <article>
          <p>
            Arcutis's topical product, Zoryve, was a large campaign encompassing
            many different digital executions. I was a part of a variety of
            emails and online ads, but my primary project for this campaign was
            a website for both patients and healthcare providers. This was a
            project that was full of challenging problems and tight deadlines,
            where I was often using tools with which I did not have much
            experience.
          </p>
          <p>
            Part of this project which I was primarily responsible for was the
            front-end of a system for patients to register for copay cards for
            the product. Successful communication with the IT team of our client
            and an external vendor was pivotal. We would frequently coordinate
            together to diagnose and fix issues with the system. You can see it 
            on the "View the website" link&nbsp;above.
          </p>
        </article>
        <article>
          <video 
            preload="auto" 
            autoPlay 
            loop 
            muted={true}
            playsInline 
            disablePictureInPicture
            poster="images/arcutis-poster-1.jpg"
          >
            <source src="videos/arcutis-video-1.mp4" type="video/mp4" />
          </video>
          <img alt="arcutis-image-1" src="images/arcutis-image-1.png" />
        </article>
      </>
    ),
  },

  neurocrine: {
    title: "NEUROCRINE",
    techUsed: "Javascript, HTML, SCSS, ASP.NET, C#, React, Node.js",
    links: (
      <>
        <a href="https://www.ingrezza.com/tardive-dyskinesia" target="_blank">
          View Ingrezza
        </a>
        <a href="https://www.morethanhd.com/" target="_blank">
          View More Than HD
        </a>
      </>
    ),
    content: (
      <>
        <article>
          <p>
            With Neurocrine I was involved with a variety of websites,
            Interactive Visual Aids (IVAs), email campaigns, and online banner
            advertisements. The largest of these was a brand called Ingrezza.
            These projects went through many different iterations and additions.
            Fast turnaround time was essential, as was coordination with my
            developer colleagues and other teams due to the large volume of
            content and detail needed for this brand.
          </p>
          <p>
            One project for this client where I was able to utilize my knowledge
            in Node.js, was for an educational site to serve patients,
            healthcare providers and others, to learn about Huntington's
            Disease. The title of the project is More Than HD. This was built
            from the ground up using vanilla JavaScript and Node.js. We built an
            anonymous, dynamic polling system to collect data about users of the
            site using that Node.js backend.
          </p>
        </article>
        <article>
          <video 
            preload="auto" 
            autoPlay 
            loop 
            muted={true}
            playsInline 
            disablePictureInPicture
            poster="images/neurocrine-poster-1.jpg"
          >
            <source src="videos/neurocrine-video-1.mp4" type="video/mp4" />
          </video>
          <video 
            preload="auto" 
            autoPlay 
            loop 
            muted={true}
            playsInline 
            disablePictureInPicture
            poster="images/neurocrine-poster-2.jpg"
          >
            <source src="videos/neurocrine-video-2.mp4" type="video/mp4" />
          </video>
        </article>
      </>
    ),
  },

  cooper: {
    title: "COOPER SURGICAL",
    techUsed: "Javascript, HTML, SCSS, Wordpress",
    content: (
      <>
        <article className="single-column">
          <p>
            This is a project that I built independently during my time at
            AbelsonTaylor. Cooper Surgical needed a temporary page for a new
            surgical device for uterine positioning. An interactive element and
            a form was necessary to show the features of the product and to
            gauge interest from potential clients. The project was built
            entirely custom in vanilla JavaScript and integrated into WordPress
            as a custom theme, using a HubSpot API and database to store data
            where our client could access it.
          </p>
        </article>
        <article className="single-column">
          <video 
            preload="auto" 
            autoPlay 
            loop 
            muted={true}
            playsInline 
            disablePictureInPicture
            poster="images/cooper-poster-1.jpg"
          >
            <source src="videos/cooper-video-1.mp4" type="video/mp4" />
          </video>
        </article>
      </>
    ),
  },
};